import { Callback } from "@siteimprove/alfa-callback";
/**
 * @public
 */
export class Emitter {
    static of() {
        return new Emitter(new Map());
    }
    /**
     * @remarks
     * Listeners are stored in a map keyed by the original listener. This ensures
     * that listeners can be deregistered even in derived emitters, such as those
     * created by `#contraMap()`.
     */
    _listeners;
    constructor(listeners) {
        this._listeners = listeners;
    }
    contraMap(mapper) {
        return new Emitter(new Map([...this._listeners].map(([key, listener]) => [
            key,
            Callback.contraMap(listener, mapper),
        ])));
    }
    on(listener) {
        this._listeners.set(listener, listener);
        return this;
    }
    once(listener) {
        const once = (done) => {
            const listener = (event) => {
                this._listeners.delete(done);
                done(event);
            };
            this._listeners.set(done, listener);
        };
        if (listener) {
            once(listener);
            return this;
        }
        else {
            return new Promise(once);
        }
    }
    off(listener) {
        this._listeners.delete(listener);
        return this;
    }
    emit(event) {
        const empty = this._listeners.size === 0;
        for (const [, listener] of this._listeners) {
            listener(event);
        }
        return !empty;
    }
    async *asyncIterator() {
        while (true) {
            yield await this.once();
        }
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
}
//# sourceMappingURL=emitter.js.map